import { render, staticRenderFns } from "./TextAnswerComponent.vue?vue&type=template&id=3e211539&scoped=true&"
import script from "./TextAnswerComponent.vue?vue&type=script&lang=ts&"
export * from "./TextAnswerComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e211539",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
